module.exports = __webpack_public_path__ + "static/media/1652771015BEKh.c76a445.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1652771015BEKh.mp3
// module id = cHSF
// module chunks = 1